import React, {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {VerdocsInitialDialog} from '@verdocs/web-sdk-react';
import {useCurrentProfile} from '../../react-sdk/queries';
import {Content, SubTitle} from '../../Components';

export const Initials: FC = observer(() => {
  const currentProfile = useCurrentProfile();
  console.log('Current Initials', currentProfile?.initials);

  // TODO: Finish this view
  return (
    <Content>
      <SubTitle>Saved Initials</SubTitle>

      <VerdocsInitialDialog initials={'CR'} style={{position: 'relative', background: 'none', width: 340}} />
    </Content>
  );
});
